<template>
    <!-- Start Main Content -->
    <div v-show="!isBarcodePrint" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Product Transaction Report</h2>
        </div>

  
<!-- Filter Form -->
<!--<div class="card p-4 mb-4">-->
<!--    <form @submit.prevent="filterPurchases">-->
<!--        <div class="flex flex-col lg:flex-row lg:items-center lg:space-x-4 space-y-4 lg:space-y-0">-->
            <!-- Start Date -->
<!--            <div class="w-full lg:w-auto mt-4">-->
<!--                <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>-->
<!--                <input type="date" id="startDate" v-model="startDate" class="p-2 border border-gray-300 rounded w-full" />-->
<!--            </div>-->
            
            <!-- End Date -->
<!--            <div class="w-full lg:w-auto ml-2">-->
<!--                <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>-->
<!--                <input type="date" id="endDate" v-model="endDate" class="p-2 border border-gray-300 rounded w-full" />-->
<!--            </div>-->

             <!-- Filter Button -->
<!--             <div class="w-50 lg:w-auto ml-2">-->
<!--                <button type="submit" class="btn b-solid btn-primary-solid px-5 cursor-pointer w-full lg:w-auto mt-2 lg:mt-6">Filter</button>-->
<!--            </div>-->
            
            <!-- Vendor Filter -->
<!--            <div class="w-full lg:w-auto ml-2"  style="width: 150px;">-->
<!--                <label for="vend_name" class="block text-sm font-medium text-gray-700">Select Vendor</label>-->
<!--                <select class="form-input w-full p-2 border border-gray-300 rounded" id="vend_name" ref="VendName" v-model="sale.vendname">-->
<!--                    <option value=""></option>-->
<!--                    <option value="All">ALL</option>-->
<!--                    <option v-for="(item, index) in vendList" :key="index" :value="item.id">{{ item.name }}</option>-->
<!--                </select>-->
<!--            </div>-->
            
            <!-- Product Filter -->
<!--            <div class="w-full lg:w-auto ml-2" style="width: 150px;">-->
<!--                <label for="prod_name" class="block text-sm font-medium text-gray-700">Select Product</label>-->
<!--                <select class="form-input w-full p-2 border border-gray-300 rounded" id="prod_name" ref="ProdName" v-model="sale.prodname">-->
<!--                    <option value=""></option>-->
<!--                    <option value="All">ALL</option>-->
<!--                    <option v-for="(item, index) in prodList" :key="index" :value="item.id">{{ item.name }}</option>-->
<!--                </select>-->
<!--            </div>-->
            
           
<!--        </div>-->
<!--    </form>-->
<!--</div>-->

<!--<div class="w-full lg:w-auto lg:ml-2 mt-4 mb-2 ml-2">-->
<!--    <button @click="exportToExcel" class="w-full lg:w-auto btn btn-primary-solid px-5 mt-2 lg:mt-6 cursor-pointer">-->
<!--        Export-->
<!--    </button>-->
<!--</div>-->
<!--<div class="printonly">-->
<!--    From {{startDate}} To {{endDate}}-->
<!--</div>-->





                    <!-- <div class="card"> -->
                        <!-- Static heading -->
                        <!-- <div id="printable-content">
                            <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
                            <h1 class="print-only" style="text-align: center;">Purchase Report</h1>
                        </div>

                        <button
                            type="reset"
                            @click="printReceipt"
                            class="btn b-light btn-danger-light btn-sm"
                        >
                            Print
                        </button>
                        </div> -->




            <!-- Loading Spinner -->
            <div v-if="isLoading" class="flex justify-center items-center h-32">
                <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Data is Loading...</span>
                </div>
            </div>

        <div class="grid grid-cols-12"  v-if="isTableVisible">
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4 table-responsive">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Tr.Id.</th>
                                    <th class="bg-[#B2E8D9]">Branch Name</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Details</th>
                                    <th class="bg-[#B2E8D9]">Product</th>
                                    <th class="bg-[#B2E8D9]">Batch No</th>
                                    <th class="bg-[#B2E8D9]">Manufacturing <br> Date</th>
                                    <th class="bg-[#B2E8D9]">Expiry <br> Date</th>
                                    <th class="bg-[#B2E8D9]">Location</th>
                                    <th class="bg-[#B2E8D9]">Quantity</th>
                                    <th class="bg-[#B2E8D9]">Rate</th>
                                    <th class="bg-[#B2E8D9]">Total</th>
                                    <th class="bg-[#B2E8D9]">Remark</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item, index) in productTransactionList" :key="item.id">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.branch_name }}</td>
                                    <td>{{ item.entrydate }}</td>
                                    <td>{{ item.vendor_name || item.emp_name || item.byuser_name }}</td>
                                    <td>{{ item.product_name }}</td>
                                    <td>{{ item.batchNo }}</td>
                                    <td>{{ item.mfgDate }}</td>
                                    <td>{{ item.expiryDate }}</td>
                                    <td>{{ item.productlocation }}</td>
                                    <td>{{ item.qty }}</td>
                                    <td>{{ item.rate }}</td>
                                    <td>{{ (item.qty * item.rate).toFixed(2) }}</td> <!-- Calculate Total for each row -->
                                    <td>{{ item.note || ((item.purid>0)? 'Purchase id #'+item.purid:'' ) || ((item.saleid>0)? 'Consumption id #'+item.saleid:'' )}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="9" class="font-bold text-right">Total:</td>
                                    <td colspan="" class="font-bold text-right">{{totalQuantity}}</td>
                                    <!-- <td class="font-bold">{{ totalQuantity }}</td>
                                    <td class="font-bold">{{ totalRate }}</td> -->
                                    <td class="font-bold"></td> 
                                    <td class="font-bold">{{ totals }}</td> 
                                    <td class="font-bold"></td> 
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
        </div>
    </div>
    <!-- End Main Content -->
    
    <!-- Start Delete Modal -->
    
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>

<script>
import axios from 'axios'; 

export default {
    name: 'productFullReport',
    components: { 
    },
    mounted() {
        if(this.$route.query.q)
            this.getBasics(this.$route.query.q);
    },
     watch: {
         productTransactionList () { // data used in the table
           this.$nextTick (() => { // wait until data fully updated before re-render new DOM 
             $('.datatable').DataTable().draw();
           })
         },
     },
    data() {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
        return {
            isBarcodePrint: false,
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            productsList: [], // This is where your product list is stored
            prodList:[],
            startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
            endDate: today,
            isTableVisible: false, // Initially table is hidden
            selectedType: 0, // Add selectedType for filtering
            datatable: null,
            productss: { iddate: '' },
            employees: { empname: '', emprole: '0', isMainAdmin: 0 },
            productTransactionList: [],
            original_productsList :[], // To store filtered results
            all_prodList:[],
            isLoading: false, // Flag for loading spinner
            sale: {
            prodname: null,
            vendname:null,
        },

        }
    },
    computed: {
        totalQuantity() {
            return this.productTransactionList.reduce((total, item) => total + (parseFloat(item.qty) || 0), 0);
        },
        totalRate() {
            return this.productTransactionList.reduce((total, item) => total + (parseFloat(item.rate) || 0), 0).toFixed(2); // Fixed to 2 decimal places
        },
        totals() {
        return this.productTransactionList.reduce((total, item) => total + (parseFloat(item.qty) * parseFloat(item.rate) || 0), 0).toFixed(2); // Calculate total based on qty and rate
    }
    },
    methods: {
        printBarcode() {
            this.isBarcodePrint = !this.isBarcodePrint;
        },
        exportToExcel() {
    // Prepare the CSV header
    const headers = ["iddate", "vendor_name", "product_name", "qty", "rate"];
    const rows = this.productTransactionList.map(item => [
        this.formatDate(item.iddate),
        item.vendor_name,
        item.product_name,
        item.qty,
        item.rate,
    ]);

    // Combine headers and rows into a CSV string
    const csvContent = [headers, ...rows]
        .map(row => row.map(value => `"${value}"`).join(","))
        .join("\n");

    // Create a Blob from the CSV content
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // Trigger a download
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "purchasereport.csv");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
},

formatDate(date) {
    if (!date) return "";  // Return empty string if date is missing or null
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";  // Return empty if invalid date
    return d.toLocaleDateString();  // Format the date as per your requirement
},

        closeModal() {
            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
            this.isAdd = 0;
            this.isEdit = 0;
            this.isDelete = 0;
            this.deleteId = 0;
        },
        deleteModal(id) {
            this.deleteId = id;
            if (!this.isDelete)
                $("#deleteModal").removeClass('hidden');
            else
                $("#deleteModal").addClass('hidden');
            this.isDelete = !this.isDelete;
        },



        refreshDatatble() {
              $('#basicDataTable').DataTable( {
                dom: 'Bfrtip',
                buttons: [
                    'print',
                    'excelHtml5',
                    'csvHtml5',
                    'pdfHtml5'
                ]
            } );
         },


        async getBasics(prdid) {
            this.isLoading = true; // Show the spinner while filtering
            var self = this;
            axios.post('getProductTrnsreport',{prdid:prdid}).then(function (response) {
                
                self.productTransactionList = response.data.products;
                self.employees = response.data.userDetails;
                 self.isTableVisible = true;
  

            }).then(() => {

                self.refreshDatatble();

               
                                    }).finally(function () {
                                        self.isLoading = false; // Hide the spinner after the request
            });
        },




 
    }
}
</script>

<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
        display: block; 
    }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>